import { Box, Form, ModBox, Text } from '@jfs/ui-new'
import { Button } from '../../components/AdminButton'
import { isEmpty, isEmptyObject } from '@jfs/utils'
import { useState } from 'react'
import { useStores } from '../../data/store'
import { isAccessible } from '../../utils'
import { formData } from './formData'

export const Account = ({ data, index, isAdd, groupId, subGroupId, addSourceAccountConfigApi, addApiState }: any) => {
  const { accessConfig, entityList } = useStores((store) => ({
    accessConfig: store.user.getAccessConfig(['ess', 'source_account_config']),
    entityList: store?.processingEntity?.getProcessingEntityListForSourceAccount,
  }))

  if (isEmptyObject(data)) {
    return null
  }
  const [fromDate, setFromDate] = useState(new Date(data?.startDate ? data?.startDate : new Date()))
  const [toDate, setToDate] = useState<Date>(data?.endDate ? data?.endDate : new Date())

  const handlePress = (values) => {
    if (isAdd) {
      isAccessible(accessConfig, 'add') &&
        addSourceAccountConfigApi({ ...values, groupId: groupId, subGroupId: subGroupId }, isEmpty(data?.accNumber))
    } else {
      isAccessible(accessConfig, 'update') &&
        addSourceAccountConfigApi({ ...values, groupId: groupId, subGroupId: subGroupId }, isEmpty(data?.accNumber))
    }
  }

  const renderActionButton = ({ values, isValid }: any) => {
    if (values?.startDate) {
      setFromDate(values.startDate)
    }
    if (values?.endDate) {
      setToDate(values.endDate)
    }
    return (
      <Button
        title={isAdd ? 'Add' : 'Update'}
        onPress={() => handlePress(values)}
        height={36}
        isFull
        isLoading={addApiState === 'pending'}
        disabled={!(isValid && (isAccessible(accessConfig, 'add') || isAccessible(accessConfig, 'update')))}
        hide={!isAccessible(accessConfig, 'add') && !isAccessible(accessConfig, 'update')}
      />
    )
  }

  return (
    <Box w={'100vh'}>
      <ModBox show={index > 0} h={'1'} marginVertical={16} bg={'PRIMARY_GREY'} />
      <Text title={`Account ${+index + 1}`} fontFamily={'jiotype-bold'} fontSize={14} color={'BLACK_21'} />
      <Form
        formData={formData(fromDate, toDate, entityList())}
        container={FormBox}
        actionButtons={renderActionButton}
        initialValues={data}
      />
    </Box>
  )
}

const FormBox = ({ children }: any) => {
  return <Box w={360}>{children}</Box>
}
